<script setup>
import { ref } from 'vue';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';

const props = defineProps({
  options: {
    type: Array,
    default: () => { },
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  trackBy: {
    type: String,
    default: '',
  },
  placeHolder: {
    type: String,
    default: '',
  },
  selectLabel: {
    type: String,
    default: '',
  },
  deselectLabel: {
    type: String,
    default: '',
  },
});

const config = ref({
  multiple: props.multiple,
  label: props.label,
  trackBy: props.trackBy,
  placeHolder: props.placeHolder,
  selectLabel: props.selectLabel,
  deselectLabel: props.deselectLabel,
});

defineExpose({ props });
</script>
<template>
  <Multiselect v-bind="config" :options="options" />
</template>
